import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function AbstractPage() {
  return (
    <div
      id="pdf"
      style={{
        width: "100%",
        height: "80vh",
        paddingLeft: "2%",
        paddingRight: "2%",
      }}
    >
      <iframe
        src="images/article/article_pdf.pdf#toolbar=0&view=FitH"
        width="100%"
        height="95%"
        style={{
          border: "none",
          borderColor: "white",
          borderRadius: "20px",
        }}
      ></iframe>
    </div>
  );
}

export default AbstractPage;
